const EVENTS_ES = {
  accepted: "Oferta aceptada por el cliente",
  booking_auto_extended: "Prórroga automática",
  booking_end: "Solicitud de fin de reserva",
  booking_extension: "Solicitud de prórroga",
  break_repair: "Averías importantes",
  break_repair_2: "Averías menores",
  breakdown: "Avería",
  breakdown_electric: "Avería eléctrica",
  breakdown_engine: "Avería de motor",
  breakdown_mecanic: "Avería mecánica",
  breakdown_other: "Otra avería",
  canceled: "Cancelado",
  closed: "Cerrado",
  confirmed: "Pedido confirmado",
  damages_third_parties: "Reclamación de daños legales",
  delay_in_delivery: "Retraso en la entrega",
  deliveryOn: "Entrega el",
  document_compliance: "Cumplimiento de documentos",
  events: "{{count}} eventos",
  forgetting_extend: "Olvidó prorrogar",
  forgetting_recover: "Olvidó recuperar",
  from_date: "Inicio",
  hours_record: "Registro de horas",
  immobilisation: "Inmovilización",
  incompetent_operator: "Operador incompetente",
  inventory: "Inventario",
  keys: "Llave/Código: pérdida/no comunicado",
  machine_delivery: "Entrega",
  machine_retrieval: "Recuperación",
  missing_accessory: "Accesorio faltante",
  n1_control: "Control N1",
  n2_control: "Control N2",
  n3_control: "Control N3",
  no_show: "Entrega: No presentado",
  open: "Abierto",
  openEvents: "Eventos abiertos",
  operator_change: "Cambio de operador",
  other: "Otro",
  other_delivery: "Otra entrega",
  other_request: "Otra solicitud",
  quality_issue: "Equipo en mal estado",
  retrievalOn: "Recuperación el",
  robbery_accessory: "Robo de accesorio",
  robbery_article: "Robo de máquina",
  sent: "Solicitud recibida",
  to_date: "Fin",
  undeclared_use: "Uso no declarado",
  validated: "Solicitud de reserva validada",
  weather: "Mal tiempo",
  wrong_machine: "Error de equipo",
  wrong_reclassification: "Selección incorrecta de máquina",
} as const;

export default EVENTS_ES;
